import { format } from "date-fns";
import { ActionTimeInfo } from "./ItemActionTimeInfo.types";

export function formatInfo(
  info: ActionTimeInfo,
  dateFormat: string
): string | undefined {
  const { timestamp, action } = info;
  return timestamp
    ? `${action} ${format(new Date(timestamp), dateFormat)}`
    : undefined;
}
